import React from 'react'

import Header from '../components/Politica/header'
import Footer from '../components/footer/footer'
import Details from '../components/Politica/details'

const Politica = () => {
  return (
    <div>
      <div id="preloader">
        <div id="loader"></div>
      </div>
      <div id="main" className="main-content-wraper">
        <div className="main-content-inner">
          <Header />
          <Details />
          <Footer />
        </div>
      </div>
    </div>
  );
}
export default Politica;